export const setPath = (navigate: any, id: any) => navigate(`/${id}`); // TODO: avoid using this helper
